module.exports = __webpack_public_path__ + "img/auth-status-failed-icon.f8856eb4.svg";